import React from 'react';
import moment from 'moment-timezone';
import BringgMobileCalendar from './mobile/bringg-mobile-calendar/bringg-mobile-calendar';
import { BringgCalendarProps } from './bringg-calendar.types';
import BringgDesktopCalendar from './desktop/bringg-desktop-calendar/bringg-desktop-calendar';
import { ScreenType } from '../../types/common.consts';

const BringgCalendar = ({
	value,
	onChange,
	className,
	screenType,
	showYearNavigation,
	minDateNav,
	maxDateNav,
	dateCellRender,
	shouldDisableDate,
	locale = 'en',
	timezone = moment.tz.guess(),
	allowClear = true,
	selectionMode = 'single',
	weekStartsOn = 'Sunday',
	fullscreen = true
}: BringgCalendarProps) => {
	switch (screenType) {
		case ScreenType.MOBILE:
			return (
				<BringgMobileCalendar
					value={value}
					onChange={onChange}
					showYearNavigation={showYearNavigation}
					selectionMode={selectionMode}
					weekStartsOn={weekStartsOn}
					minDateNav={minDateNav}
					maxDateNav={maxDateNav}
					shouldDisableDate={shouldDisableDate}
					locale={locale}
					timezone={timezone}
					allowClear={allowClear}
					className={className}
				/>
			);

		case ScreenType.DESKTOP:
		default:
			return (
				<BringgDesktopCalendar
					value={value}
					onChange={onChange}
					showYearNavigation={showYearNavigation}
					minDateNav={minDateNav}
					maxDateNav={maxDateNav}
					shouldDisableDate={shouldDisableDate}
					dateCellRender={dateCellRender}
					fullscreen={fullscreen}
					locale={locale}
					timezone={timezone}
					className={className}
				/>
			);
	}
};

export default BringgCalendar;
